import React from 'react'

import {
  ProfileIconImage,
  ProfileIconName,
  ProfileIconNameWrapper, ProfileIconRole,
  ProfileIconWrapper
} from './style'
import capitalize from 'utils/capitalize'

const firstLetter = 0
const ProfileIcon = ({ user, reviewer = false, ...props }) => {

  return (
    <ProfileIconWrapper data-testid='test-profile-icon-wrapper' data-test='user-details'>
      <ProfileIconImage data-testid='test-profile-icon-image' data-test='user-badge' {...props}>
        <p>
          {user.firstName.charAt(firstLetter).toUpperCase() + user.lastName.charAt(firstLetter).toUpperCase()}
        </p>
      </ProfileIconImage>
      <ProfileIconNameWrapper data-testid='test-profile-icon-name-wrapper'>
        <ProfileIconName data-testid='test-profile-icon-name' data-test='user-name'>
          {`${capitalize(user.firstName)} ${capitalize(user.lastName)}`}
        </ProfileIconName>
        <ProfileIconRole data-testid='test-profile-icon-role' data-test='user-role'>
          {reviewer ? user.email : props.isInCommentSection ? user.organisation ? `@${user.organisation}` : '' : user.Role.name}
        </ProfileIconRole>
      </ProfileIconNameWrapper>
    </ProfileIconWrapper>
  )
}

export default ProfileIcon
